// const moment = require('./moment.min.js');
// 为了减少文件体积，使用dayjs代替moment
const dayjs = require('./dayjs.min.js');

export default dayjs;